import withGetService from './with-get-service';

export default withGetService;
